import React, {FC} from 'react';
import {PageHead} from 'components/PageHead';
import Wrapper, {PageStyle} from 'components/Wrapper';
import {graphql} from 'gatsby';
import {getImage, GraphQLImage, ImageUse} from 'utils/types/image';

import Post from './Post';
import {Recs} from './Recs';

export const query = graphql`
query ($slug: String) {
	post: airtable(data: {Slug: {eq: $slug}}) {
		data {
			author: Author {
				data {
					name: Name
					avatar: Avatar {
						localFiles {
							childImageSharp {
								gatsbyImageData(width: 200)
							}
						}
					}
				}
			}
			minutes: Minutes
			published: Published
			title: Title
			images: Images {
				data {
					altText: Alt_Text
					use: Use
					image: Image {
						localFiles {
							childImageSharp {
								gatsbyImageData(
									width: 1536,
									formats: [JPG, WEBP],
								)
							}
						}
					}
				}
			}
			markdown: Markdown
		}
	}
}`;

interface PostPageProps {
	data: {
		post: {
			data: {
				author: {
					data: {
						name: string;
						avatar: GraphQLImage;
					};
				}[];
				images: {
					data: {
						altText: string;
						use: string;
						image: GraphQLImage;
					};
				}[];
				minutes: number;
				published: string;
				title: string;
				markdown: string;
			};
		};
	};
}

const PostPage: FC<PostPageProps> = ({
	data: {
		post: {data},
	},
}) => {
	const titleImage = data.images.find(
		({data}) => data.use === ImageUse.primary
	);
	if (!titleImage) {
		throw new Error(`No primary image: '${data.title}'`);
	}

	const post = {
		author: {
			name: data.author[0].data.name,
		},
		image: {
			alt: titleImage.data.altText,
			image: getImage(titleImage.data.image),
		},
		minutes: data.minutes,
		published: data.published,
		title: data.title,
		content: {
			markdown: data.markdown,
			images: data.images
				.filter(({data}) => data.use === ImageUse.content)
				.map(({data}) => ({
					alt: data.altText,
					image: getImage(data.image),
				})),
		},
	};

	return (
		<Wrapper style={PageStyle.PostPage}>
			<Post {...post} />
			<Recs seed={post.title} />
		</Wrapper>
	);
};

export default PostPage;

export const Head = PageHead<PostPageProps>(
	({data}) => {
		return {
			title: data.post.data.title,
		};
	}
);
